import axios from 'axios';
import Mailformstyle from '@/models/Mailformstyle';
import Mailform from '@/models/Mailform';
import MailFormTemplate from '@/models/MailFormTemplate';
import Notify from '@groovepages/gd-ui-kit/notify';
import i18n from '../../plugins/i18n.js';

i18n.locale = 'localStorage' in window ? localStorage.getItem('lang') : 'en';

function newDefaultPreset() {
  return {
    name: "Default Style",
    styles: {
      advanced: {
        fields: {},
      },
      form: {
        backgroundColor: "#ffffff",
        padding: [28,28,28,28],
        margin: [0,0,0,0],
        style: "clear",
        color: "#000000",
        border: {
          radius: [0,0,0,0],
          color: ["#000000","#000000","#000000","#000000"],
          width: [0,0,0,0],
          style: ["solid","solid","solid","solid"],
        },
      },
      paragraphs: {
        text: {
          fontWeight: 400,
          color: 'inherit',
          fontFamily: 'default',
          textAlign: 'center',
          fontSize: 12,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          textStrokeWidth: null,
          textStrokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
        padding: [0,0,0,0],
        margin: [0,0,0,0],
      },
      heading: {
        text: {
          fontWeight: 400,
          color: 'inherit',
          fontFamily: 'default',
          textAlign: 'center',
          fontSize: 20,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          textStrokeWidth: null,
          textStrokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
        padding: [0,0,0,0],
        margin: [0,0,0,0],
      },
      subheading: {
        text: {
          fontWeight: 400,
          color: 'inherit',
          fontFamily: 'default',
          textAlign: 'center',
          fontSize: 12,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          textStrokeWidth: null,
          textStrokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
        padding: [0,0,0,0],
        margin: [0,0,0,0],
      },
      field: {
        text: {
          fontWeight: 400,
          color: "#000000",
          fontFamily: 'default',
          textAlign: 'left',
          fontSize: 12,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          textStrokeWidth: null,
          textStrokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
        border: {
          radius: [5,5,5,5],
          color: ["#000000","#000000","#000000","#000000"],
          width: [1,1,1,1],
          style: ["solid","solid","solid","solid"],
        },
        placeholderColor: "#000000",
        labelColor: "#000000",
        backgroundColor: "#ffffff",
        iconColor: "#000000",
        padding: [8,8,8,8],
        margin: [12,12,12,12],
        icon: 'none',
      },
      button: {
        backgroundColor: "rgb(47, 128, 237)",
        border: {
          radius: [5,5,5,5],
          color: ["#000000","#000000","#000000","#000000"],
          width: [1,1,1,1],
          style: ["solid","solid","solid","solid"],
        },
        padding: [8,8,8,8],
        margin: [12,12,12,12],
        icon: 'none',
        text: {
          fontWeight: 400,
          color: '#000000',
          fontFamily: 'default',
          textAlign: 'center',
          fontSize: 16,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          strokeWidth: null,
          strokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
        alignment: 'full',
      },
      button_sublabel: {
        padding: [0,0,0,0],
        margin: [0,0,0,0],
        text: {
          fontWeight: 400,
          color: '#000000',
          fontFamily: 'default',
          textAlign: 'center',
          fontSize: 13,
          textDecorationLine: '',
          fontStyle: '',
          letterSpacing: null,
          lineHeight: null,
          strokeWidth: null,
          strokeColor: null,
          textShadow: 'rgba(0, 0, 0, 0.1) 0 0 0',
        },
      }
    }
  }
}

function getName(name, mailFormStyles, count = 1) {
    let nameToSearch = name;
    if (count > 1) {
        nameToSearch = `${name} ${count}`;
    }
    const exists = mailFormStyles.some(style => style.name === nameToSearch);
    if (exists) {
        count += 1;
        return getName(name, mailFormStyles, count);
    }
    return nameToSearch;
}


export default {
  state: {
    presets: [],
    templates: {
        global: [],
        personal: [],
    },
    layoutType: '',
    alignment: 'center',
    hideLabels: false,
    activePresetId: null,
    printing: false,
    singleScreenOverride: false,
    viewMode: 'lg',
    previewWidth: '992',
    loading: false,
    loadingTemplates: false,
    isStyleChanged: false,
    activeFormId: null,
    formStyleBuilder: false,
  },

  getters: {
    activePreset: state => state.presets.find(preset => preset.id === state.activePresetId),
    activeFormId: state => state.activeFormId,
    isStyleChanged: state => state.isStyleChanged,
    formStyleBuilder: state => state.formStyleBuilder,
  },

  mutations: {
    SET_LOADING_TEMPLATES(state, payload) {
      state.loadingTemplates = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PRINTING(state, payload) {
      state.printing = payload;
    },
    SET_LAYOUT_TYPE(state, payload) {
      state.layoutType = payload;
    },
    SET_HIDE_LABELS(state, payload) {
      state.hideLabels = payload;
    },
    SET_PREVIEW_WIDTH(state, payload) {
      state.previewWidth = payload;
    },
    SET_ALIGNMENT(state, payload) {
      state.alignment = payload;
    },
    SET_TEMPLATES(state, payload) {
      state.templates = payload;
    },
    SET_PRESETS(state, payload) {
      payload.sort((a, b) => {
        if(a.default === true){
          return -1;
        }
        return 0;
      });
      state.presets = payload;
    },
    SET_ACTIVE_PRESET(state, payload) {
      state.activePresetId = payload;
    },
    SET_STYLE_OVERRIDE(state, active) {
      state.singleScreenOverride = active;
    },
    SET_SCREEN_SIZE(state, size) {
      state.viewMode = size;
    },
    SET_STYLE_CHANGED(state, payload) {
      state.isStyleChanged = payload;
    },
    SET_ACTIVE_FORM_ID(state, payload) {
      state.activeFormId = payload;
    },
    SET_FORM_STYLE_BUILDER(state, payload) {
      state.formStyleBuilder = payload;
    },
  },

  actions: {
    /**
     * Templates
    */
    async useTemplate({ commit, dispatch, state}, info) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);

      // set the preset data to the template data
      const preset = {
        name: getName(info.template.name, state.presets),
        styles: JSON.parse(JSON.stringify(info.template.styles)),
      };

      // save the preset
      dispatch('savePreset', preset);

      // stop loader
      commit('SET_LOADING_TEMPLATES', false);
    },

    // save the current form as a template
    async saveAsTemplate({ commit, dispatch, state}, info) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);

      // save the template to the database
      const res = await axios.post('/mailform/save-as-template', {
        form_id: info.form_id,
        preset_id: state.activePresetId,
        thumbnail_data: info.thumbnail_data,
      });

      // check if the template was saved successfully and show a notification
      if (res.status === 201) {
        Notify.success(i18n.t('frontend_template_saved_successfully'));
      } else{
        Notify.fail(
          i18n.t('frontend_backend_error')
        );
      }
      
      // stop loader
      commit('SET_LOADING_TEMPLATES', false);
      
      // reload templates
      dispatch('loadTemplates');
    },

    // load the templates
    async loadTemplates({ commit, dispatch }) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);
      
      // get templates from database
      const templates = await MailFormTemplate.get();

      // set templates
      commit('SET_TEMPLATES', templates[0]);

      // stop loader
      commit('SET_LOADING_TEMPLATES', false);
    },


    // save a template
    async saveTemplate({ commit, dispatch }, template) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);

      // save template
      const templateModel = new MailFormTemplate(template);
      await templateModel.save();

      // stop loader
      commit('SET_LOADING_TEMPLATES', false);

      // reload templates
      dispatch('loadTemplates');
    },

    // update template
    async updateTemplate({ commit, dispatch }, template) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);

      // update template
      const templateModel = new MailFormTemplate();
      await templateModel.templateUpdate(template);

      // stop loader
      commit('SET_LOADING_TEMPLATES', false);

      // reload templates
      dispatch('loadTemplates');
    },

    // delete a template
    async deleteTemplate({ commit, dispatch }, template) {
      // show loader
      commit('SET_LOADING_TEMPLATES', true);

      // delete template
      const templateModel = new MailFormTemplate();
      const response = await templateModel.templateDelete(template.id);
      
      // check if the template was deleted successfully and show a notification if not
      if(response.status !== 204){  
        Notify.fail(i18n.t('frontend_backend_error'));
      }

      // stop loader
      commit('SET_LOADING_TEMPLATES', false);

      // reload templates
      dispatch('loadTemplates');
    },


    /**
     * Presets
    */

    // set the active preset and load it from the database if it is not loaded yet
    async setActivePreset({ commit, dispatch, state}, presetId) {
      if (!state.presets.find(preset => preset.id === presetId)) {

        // show notification if the preset was not found
        Notify.fail(i18n.t('frontend_requested_preset_not_found'));
        return;
      }
      
      // check if the preset is already loaded and set it as active if it is
      if(state.presets.find(preset => preset.id === presetId).styles){
        commit('SET_ACTIVE_PRESET', presetId);
        // state.activePresetId = presetId;
        return;
      }

      // show loader
      commit('SET_LOADING', true);

      // load the preset from the database
      const preset = await Mailformstyle.$find(presetId);

      // hide loader
      commit('SET_LOADING', false);

      commit('SET_PRESETS', state.presets.map(item => {
        let newPresets = item;

        if(item.id === presetId){
          newPresets = preset;
        }

        return newPresets;
      }));
      
      // set the style change to false
      commit('SET_STYLE_CHANGED', false);
      
      commit('SET_ACTIVE_PRESET', presetId);
    },

    // load the presets from the database
    async loadPresets({ commit, dispatch, state }, activePreset = null) {

      // check if the form have a preset
      if (!activePreset) {
        // set to default preset if the form have no preset
        activePreset = state.activePresetId;
        
      }

      // show loader
      commit('SET_LOADING', true);

      // get presets from database
      const presets = await Mailformstyle.params({active: activePreset}).get();
      
      // hide loader
      commit('SET_LOADING', false);

      if(presets.length === 0) {
        await dispatch('addPreset', {form: null, name:null});
        return;
      }

      // set the presets
      await dispatch('setPresets', presets);
    },

    // set the presets and set the active preset if it is not set yet
    async setPresets({commit, dispatch, getters, state}, presets) {
      // set the presets
      commit('SET_PRESETS', presets);

      // set the active preset if it is not set yet
      if(state.activePresetId == null || !getters.activePreset.styles) {
        await dispatch('setActivePreset', state.presets[0].id);
      }
    },

    // add a new preset to the database and the presets array
    async addPreset({ commit, dispatch, getters }, { preset = null, name = null }) {
      if (!preset) {
        preset = newDefaultPreset();
      } else {
        if (!preset.styles) {
          await dispatch('setActivePreset', preset.id);
          preset = getters.activePreset;
        }
        preset = JSON.parse(JSON.stringify(preset));
        preset.name = preset.name + ' Clone';
        delete preset.id;
        delete preset.default;
      }
      if (name) {
        preset.name = name;
      }

      dispatch('savePreset', preset);
    },

    // set the default preset
    async setPresetAsDefault({ commit, dispatch }, preset) {

      // set the preset as default in the database
      const res = await axios.post('/mailformstyle/set-as-default', {
        id: preset.id,
      });


      // check if the preset was set as default successfully and show a notification if not
      if (res.status === 200) {
        Notify.success(i18n.t('frontend_preset_set_as_default'));
      } else{
        Notify.fail(i18n.t('frontend_backend_error'));
      }

      // reload presets
      dispatch('loadPresets');
    },

    // save a preset to the database or update it if it already exists there (based on the id)
    async savePreset({ commit, dispatch, state }, preset) {
      
      // show loader
      commit('SET_LOADING', true);
      
      // create new mail form style model
      const mailformstyle = new Mailformstyle(preset);
      
      // // set the preset data
      const response = await mailformstyle.save();
      
      // hide loader
      commit('SET_LOADING', false);

      // if the preset is new, add it to the presets array
      if(!preset.id){
        const newPresets = JSON.parse(JSON.stringify(state.presets));
        newPresets.unshift(response);
        
        dispatch('setPresets', newPresets);
  
        await dispatch('setActivePreset', response.id);

        return;
      }

      // if the preset already exists, update it in the presets array
      const newPresets = state.presets.filter(i => i.id !== response.id);
      newPresets.unshift(response);

      // save new presets
      dispatch('setPresets', newPresets);
    },


    // save a preset to the database or update it if it already exists there (based on the id)
    async updatePreset({ commit, dispatch }, preset) {
      // show loader
      commit('SET_LOADING', true);
      
      // create new mail form style model
      const mailformstyle = new Mailformstyle();
      
      // update the preset data in the database
      await mailformstyle.formStyleUpdate(preset);
      
      // reload presets
      await dispatch('loadPresets');
     
      // hide loader
      commit('SET_LOADING', false);
    },

    // create new local preset and save it to the database with form_id and save_mode
    async createLocalPreset({ commit, dispatch }, preset) {

      // show loader
      commit('SET_LOADING', true);

      // check if the preset alraedy saved locally or not
      if(preset.form_id === null || preset.form_id === undefined){
        // create local preset with form id and save mode
        const localPreset = {
          name: `${preset.name} - ${i18n.t('frontend_local_preset')}`,
          styles: preset.styles,
          form_id: preset.formId,
          save_mode: 'custom',
        };
        
        // save the new local preset to the database
        const mailformstyle = new Mailformstyle(localPreset);
  
        
        // save the preset to the database
        const response = await mailformstyle.save();
        
        // reload presets
        await dispatch('loadPresets');
        
        // set the active preset to the new local preset
        await dispatch('setActivePreset', response.id);
      } else {
        // update the local preset in the database
        await dispatch('updatePreset', preset);
      }

      // hide loader
      commit('SET_LOADING', false);
    },

    // delete a preset from the database and the presets array
    async deletePreset({ commit, dispatch, state }, preset) {

      // create new mail form style model
      const mailformstyle = new Mailformstyle();

      // show loader
      commit('SET_LOADING', true);
      
      // delete preset from the database
      const response = await mailformstyle.formStyleDelete(preset.id);
      
      // check if the preset was deleted successfully and show a notification if not
      if(response.status === 204){  
        // set the active preset to the first preset if it is the preset that is being deleted
        dispatch('setActivePreset', state.presets[0].id);

        // reload presets
        await dispatch('loadPresets');
      } else {
        Notify.fail(i18n.t('frontend_backend_error'));
      }

      // hide loader
      commit('SET_LOADING', false);
    },

    // set the style override
    setIsStyleChanged({ commit }, payload) {
      commit('SET_STYLE_CHANGED', payload);
    },

    // set the form id
    setActiveFormId({ commit }, payload) {
      commit('SET_ACTIVE_FORM_ID', payload);
    },

    // set the form style builder
    setFormStyleBuilder({ commit }, payload) {
      commit('SET_FORM_STYLE_BUILDER', payload);
    },
  },

  namespaced: true
};
